import React from 'react';
import { cx } from './cx';

export interface PageShellProps {
  /** narrow 40rem (forms, support), default 60rem, wide 80rem (lobby, wallet): 640 / 960 / 1280px at scale 1. */
  width?: 'narrow' | 'default' | 'wide';
  className?: string;
  children: React.ReactNode;
}

const WIDTH = { narrow: 'max-w-[40rem]', default: 'max-w-[60rem]', wide: 'max-w-[80rem]' } as const;

/** Page column: one of three widths, shared gutters and vertical rhythm. */
export default function PageShell({ width = 'default', className, children }: PageShellProps) {
  return <div className={cx('mx-auto flex w-full min-w-0 flex-col gap-4 px-4 pb-6 pt-4 @bp-sm:gap-6 @bp-sm:px-6 @bp-sm:pt-6', WIDTH[width], className)}>{children}</div>;
}
